import { retrieveToken } from '../storage';
import {
  wrapFetch,
  apiFetch,
  apiError,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getReparti = (manualeId, page, size, sortby) => {
  const PATH = '/api/reparti';
  let query =
    '?' +
    'page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  if (manualeId !== null) {
    query = query + '&manualeId.equals=' + manualeId;
  }
  const URL = BASE_URL + PATH + query;
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const updateReparti = (manualeId, arrayReparti) => {
  const PATH = '/api/reparti';
  const requestBody = {
    manualeId: manualeId,
    reparti: arrayReparti,
  };
  const URL = BASE_URL + PATH;
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: SALVATAGGIO_DATI_NON_CORRETTI,
    }),
  );
};
